<template>
<div>
<ContentOverlay ></ContentOverlay>
<div class="content_card" >

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>



<div class="grid" v-if="!loading">

<div class="col-12 md:col-2">
<div class="content_card_content sticky_panel">


<!-- brand-->
<template v-if="item.brand">
  <div class="col-12" >
<h4 class="text-primary m-0"><b>{{this.$store.state.languages.lang_phrases.marka}}</b></h4>
</div>
<div class="col-12 mb-2 py-1" >
<small class="p-link" >
  <router-link class="no-underline text-primary text-sm" :to="{ name: 'Brand', params: { id: item.brand.id }}">{{ item.brand.name}}
  </router-link>
</small>
</div>
</template>

<!-- brand-->

<!-- project-->
<template v-if="item.projectsupplier">
  <div class="col-12" v-if="item.projectsupplier">
<h4 class="text-primary m-0"><b>{{this.$store.state.languages.lang_phrases.proje}}</b></h4>
</div>
<div class="col-12 mb-2 py-1" >
<small class="p-link" >
  <router-link class="no-underline text-primary text-sm" :to="{ name: 'Project', params: { id: item.projectsupplier.project.id }}">{{ item.projectsupplier.project.name}}
  </router-link>
</small>
</div>
</template>

<!-- project-->

<!-- flow-->
<template v-if="item.flowsupplier">
<div class="col-12" >
<h4 class="text-primary m-0"><b>{{this.$store.state.languages.lang_phrases.akis}}</b></h4>
</div>
<div class="col-12 mb-2 py-1" >
<small class="p-link" >
  <router-link class="no-underline text-primary text-sm" :to="{ name: 'Flow', params: { id: item.flowsupplier.flow.id }}">{{ item.flowsupplier.flow.name}}
  </router-link>
</small>
</div>
</template>

<!-- flow-->

<!-- flow-->
<template v-if="item.flowsupplier || item.projectsupplier">
<div class="col-12" >
<h4 class="text-primary m-0"><b>{{this.$store.state.languages.lang_phrases.tedarikci}}</b></h4>
</div>
<div class="col-12 mb-2 py-1" >
<small class="p-link" >
  <template v-if="item.flowsupplier">
     <router-link class="no-underline text-primary text-sm" :to="{ name: 'Supplier', params: { id: item.flowsupplier.supplier.id }}">{{ item.flowsupplier.supplier.name}}
  </router-link>
  </template>

  <template v-if="item.projectsupplier">
     <router-link class="no-underline text-primary text-sm" :to="{ name: 'Supplier', params: { id: item.projectsupplier.supplier.id }}">{{ item.projectsupplier.supplier.name}}
  </router-link>
  </template>
 
</small>
</div>
</template>

<!-- flow-->

<!-- brand-->
<template v-if="item.conversations.length">
  <div class="col-12" >
<h4 class="text-primary m-0"><b>{{this.$store.state.languages.lang_phrases.kullanici}}</b></h4>
</div>
<div class="col-12 mb-2 py-1" >
<small class="p-link" >
  <router-link class="no-underline text-primary text-sm" :to="{ name: 'User', params: { id: item.conversations[0].submitteduser.id }}">{{ item.conversations[0].submitteduser.name}}
  </router-link>
</small>
</div>
</template>

<!-- brand-->



<template v-if="!item.status">
<Button type="button"  icon="pi pi-check" label="Çözümlendi olarak işaretle" class="p-button-primary p-button-outlined p-button-sm "  @click="maskAsResolved"/> 

</template>

<template v-if="item.status">
<Tag 
class="ml-0 mt-1 custom-chip" 
:value="$store.state.languages.lang_phrases.cozumlendi" 
style="background-color:#4dc247"
/>

</template>




</div>

</div>

<div class="col-12 md:col-10">
<div class="content_card_content">



<TicketConversation :ticket="item"></TicketConversation>


</div>
</div>

</div>




</div>
 </div> 
</template>

<script>
export default {

  name: 'Ticket',

  data () {
    return {
      item:null,
      loading:true,
    }
  },
  mounted()
  {
    
    this.getData()
    this.$socket.emit('create_ticket_check_socket', { ticket_id: this.$route.params.id })
  },
  methods:{
    async getData()
    {
      this.loading = await true
      this.item = await this.generalApiGet("tickets/show_supplier_user_ticket/"+this.$route.params.id) 
      await this.$store.dispatch('tickets/setDisplayingTicket',this.item) 
      console.log(this.item)
      this.loading = await false
      setTimeout(()=>{
        let element = document.getElementById("ticket_conversation");
        element.scrollTop = element.scrollHeight;
      },10)
    },
    maskAsResolved()
    {
      let formdata = new FormData()
      this.generalSubmission(formdata,"tickets/mark_as_resolved/"+this.$store.state.tickets.displaying_ticket.id,this.afterSubmit)
    },
    async afterSubmit(response)
    {
      this.item.status = 1
      this.$store.dispatch('tickets/setDisplayingTicket',this.item) 
      let tickets_open = await this.generalApiGetWithoutLoader("tickets/get_open_admin_tickets")                
      if(tickets_open!=="close")
      {
         this.$store.dispatch('tickets/setAdminOpenTickets',true) 
         this.$store.dispatch('tickets/setAdminOpenTicketsCount',tickets_open) 
      }

    }
  }
};
</script>

<style lang="css" scoped>
</style>